<template>
  <!--查看-->
  <div>
    <el-form :model="formData" :rules="rules" v-loading="saveLoading" ref="extendForm" label-width="90px" class="houseChangeDetail" > 
      <div class="cnt-block">
        <div class="cnt-title top-title">
          <div class="m-b-16">订单信息</div>
          <div class="top-title-two font-14">
            <span class="form-label">预定人：</span>
            <span class="color-333 m-r-10">{{detailData.bookerName}}</span>
            <span class="blue-text">{{detailData.bookerPhone}}</span>
          </div>
        </div>
        <div class="cnt-items">
          <el-row :gutter="10">
            <el-col :span="14">
              <div class="flex">
                <div class="form-label w-90">订单编码：</div>
                <span class="text-ellipsis color-333" :title="detailData.orderCode">{{detailData.orderCode}}</span>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="flex">
                <div class="form-label w-90">原房源名称：</div>
                <span class="text-ellipsis color-333" :title="detailData.roomName">{{detailData.roomName}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    
      <div class="cnt-block cnt-block-blue">
        <div class="cnt-title">换房信息</div>
        <div class="cnt-items">
          <el-form-item label="入离时间：" >
            <span class="m-r-15">{{formData.startTime}} - {{formData.endTime}}</span>
            <span>共{{formData.timeStr}}</span>
          </el-form-item>
          <el-form-item prop="roomTypeId" label="新房型：">
            <el-select v-model="formData.roomTypeId"  filterable placeholder="请选择" >
              <el-option v-for="item in selOptions.roomType" :key="item.roomTypeCode"  :label="item.roomTypeName" :value="item.id+''">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="roomId" label="新房源名称：">
            <el-select v-model="formData.roomId"  filterable placeholder="请选择" >
              <el-option v-for="item in roomSelOptions" :key="item.roomCode"  :label="item.roomName" :value="item.id+''">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="roomId" label="换房原因：">
            <el-input type="textarea" :rows="3" v-model="formData.reasonRemark"  placeholder="请输入" ></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <div class="form-footer">
      <el-row :gutter="10">
        <el-col :span="14">
          <div class="room-price flex">
            <span>房费：</span>
            <span v-if="!isEditPrice" class="price">￥{{ formData.orderPrice }}</span>
            <el-input-number v-else v-model="orderPrice" :min="0" controls-position="right" />
            <el-button class="color-pri" icon="Edit" type="text" @click="isEditPrice = !isEditPrice">{{ isEditPrice ? '取消' : '手动修改' }}</el-button>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="flex-bottom w-p-100 h-p-100">
            <el-button class="submit-btn" @click="handleSave">保存</el-button>
            <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import RichText from "@/components/common/RichText/RichText";
import orderMix from './mixin.js'
import { mapActions } from 'vuex'
import commonMixin from './mixin'

export default {
  components: {RichText},
  mixins: [ orderMix, commonMixin ],
  name: "orderCancelModel",
    props:{
      selOptions: {
        type: Object,
        default:{roomType:[]},
      },
      detailModal:{
        type:Boolean,
        default:''
      },
      detailData:{
        type:Object,
        default:{}
      },
      detailType:{
        type:String,
        default:'show'
      }
    },
    data(){
      let detailKeys = ['startTime','endTime','orderType','roomId','roomTypeId','timeStr','reasonRemark','orderPrice']

      let formData = {}
      detailKeys.map((key)=>{
        formData[key] = ''
      })
      return{
        isEditPrice: false,
        orderPrice: 0,
        showType:'',
        saveLoading: false,
        detailKeys: detailKeys,
        rules:{
        },
        formData:formData,
        roomSelOptions: []
      }
  },
  mounted(){
    this.showType = this.detailType
  },
  watch:{
    detailType(val){
      this.showType = val
    },
    detailModal:{
      immediate: true,
      handler: function(to){
        if(to===false){
          return false
        }
        this.isInit = true
        this.$nextTick(()=>{
          this.$refs.extendForm.resetFields()
          this.initFormData()
        })
      }
    },
    'formData.roomTypeId'(val){
      this.pickRoomTypeChange(val)
    }
  },
  methods:{
    ...mapActions([ 'fetchData' ]),
    //初始化表单数据
    initFormData(){
      this.detailKeys.map((key)=>{
        this.formData[key] = this.detailData[key] ? this.detailData[key]:''
      })
      //已预订和已登记的记录拟入住和拟离开时间；已入住的则是记录实际的入住和拟离开时间；已完成的 是真实的入住时间和离开时间
      //1-已预订，2-已登记，3-已入住，4-已完成，5-已取消，6-已失效
      if(this.detailData.orderState==3){
        this.formData.startTime = this.detailData.actualCheckInTime
        this.formData.endTime = this.detailData.proposedCheckOutTime
      }else if(this.detailData.orderState==4){
        this.formData.startTime = this.detailData.actualCheckInTime
        this.formData.endTime = this.detailData.actualCheckOutTime
      }else{
        this.formData.startTime = this.detailData.proposedCheckInTime
        this.formData.endTime = this.detailData.proposedCheckOutTime
      }
      this.orderPrice = this.formData.orderPrice || 0

      let diffs = this.getDiffTime(this.formData.startTime,this.formData.endTime,this.formData.orderType)
      if(diffs){
        this.formData.timeStr = (this.formData.orderType==1)?diffs+'晚':diffs+'小时'
      }else{
        this.formData.timeStr = '--'
      }
      
      this.$nextTick(() => {
        this.isInit = false
      })
    },

    // 房型变更
    pickRoomTypeChange(){
      this.initRoomSels()

      if (!this.isInit) { // 进入页面时候不需要请求
        this.changeRoomPrice()
      }
    },
    // 更改房费
    changeRoomPrice() {
      let params = {
        startTime: this.formData.startTime,
        endTime: this.formData.endTime,
        roomTypeId: this.formData.roomTypeId,
      }
      let stayTime = this.getDiffTime(params.startTime, params.endTime, this.formData.orderType)
      if (this.formData.orderType == 1) {
        params.nightNum = stayTime
      } else {
        params.isHourRoom = true
        params.hourNum = stayTime
      }
      this.getRoomPrice(params, (res) => {
        this.formData.orderPrice = res
      })
    },

    //初始化房源列表
    initRoomSels() {
      let val = this.formData.roomTypeId
      let curRooms = []
      this.selOptions.rooms.length && this.selOptions.rooms.forEach((item)=>{
        if(item.roomTypeId == val){
          curRooms.push({...item})
        }
      })
      this.roomSelOptions = curRooms
      this.formData.roomId = curRooms[0].id
    },
    //保存与发布
    handleSave() {
      this.doSave('extend')
    },
    //保存操作
    doSave(type){
      let url = 'SAAS.CHANGE_HOUSE'
      let paramData = {id:this.detailData.id,remark:this.formData.reasonRemark,roomId:this.formData.roomId,orderPrice:this.formData.orderPrice}
      if (this.isEditPrice) {
        paramData.orderPrice = this.orderPrice
      }

      this.fetchData({url:url, method: 'post', params:paramData,timeout:0, isLoading:false, flag:true,headers: { "Content-Type": "application/json" }}).then((res)=>{
        if(res.code==200){
          this.$message.success(res.msg||'操作成功！')
          this.$emit('submitSuccess')
        }else{
          this.$message.error(res.msg||'操作失败！')
        }
        this.saveLoading = false
      }).catch((err)=>{
        this.$message.error('操作失败！')
        this.saveLoading = false
      }).finally (()=>{
        this.saveLoading = false
      })
    },
    handleCancel(){
      this.$emit('closeModel')
    },
  },
}
</script>

<style lang="less" scoped>
.houseChangeDetail :deep(.el-form-item__label) {
  padding: unset;
  font-weight: normal;
  color: #8c8c8c;
}
.sentContent{
  margin: 20px;
  padding: 10px;
  border: 1px solid rgba(38, 118, 165, 1) ;
}
.cnt-block {
  width: 100%;
}
.cnt-title {
  font-size: 18px;
  height: 56px;
  line-height: 56px;
  flex: 1;
}
.cnt-items {
  background: #f5f5f5;
  padding: 18px 30px;
  border-radius: 3px;
}
.cnt-block-blue {
  margin-bottom: 18px;
}
.cnt-block-blue .cnt-items {
  background: #f1faff;
}
.top-title {
  display: flex;
  width: 100%;
  .top-title-two {
    flex-grow: 1;
    text-align: right;
    padding-right: 15px;
  }
}
.room-price {
  align-items: center;
  font-size: 18px;
  .price {
    font-size: 22px;
    font-weight: bold;
    color: #ff4c4c;
  }
}
.blue-text{
  color: rgb(56, 147, 215);
  line-height: 32px;
}
.text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.form-label {
  text-align: right;
  color: #8c8c8c;
}
.color-333 {
  color: #333;
}
.flex {
  display: flex;
}
.color-pri {
  color: rgba(0, 192, 192, 1);
}
.flex-bottom {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
</style>

